<template></template>

<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';

  @Component
  export default class RestaurantRoot extends Vue {
    mounted() {
      this.$router.replace({
        name: 'restaurantDashboard',
        params: this.$route.params,
      });
    }
  }
</script>
